import { logout } from '@/_services/user.service.js';

export function handleResponse(response) {
    return response.text().then(text => {
        let data = null;
        try {
            data = text ? JSON.parse(text) : null;
        } catch {
            data = text;
        }
        if (!response.ok) {
            if (response.status === 401) {
                logout();
                //window.localStorage.clear();
                return Promise.reject(new Error('UNAUTHORIZED'));
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}
